// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import store from "../../store/";
import userModel from "../../model/login/user";
import { mapState } from "vuex";
import regex from "../../common/regex";
import { getLoginUserInfo } from "../../api/usercenter";
import { getlistTeacherClassInfo } from "../../api/usercenter";
import storage from "../../common/storage";
import "../../api/sso/sso";
import "../../api/md";
import { listRoleAuth } from "../../api/usercenter";
import config from "../../config/config";
import constants from "../../common/constants";
import loginConstants from "../../js/constants";
import utils from "../../utils/commonUtils";
import analysisRedirect from "../../js/analysis/analysisRedirect.js";
const loading = () => import("@/components/analysis/loading");

Vue.config.productionTip = false;
Vue.use(ElementUI);
/* eslint-disable no-new */

new Vue({
  el: "#wrap",
  store,
  components: {
    loading,
  },
  data: {
    user: userModel.loginInfo,
    userName: "",
    passWord: "",
    loginInfoError: false, //账号或密码错误,
    loginPass: false,
    //国家通用语言文字学习平台-中小学版允许登录的角色集合
    roleCodes: [
      "student",
      "teacher",
      "subjectLeader",
      "instructor",
      "cityAdmin",
      "provinceAdmin",
      'cityInstructor',
      'proInstructor'
    ],
    oldaddress: "",
    checked: false,
    codeType: "third", // 验证类型 third/pic
    captchaUrl: "", // 验证码图片
    msg: "",
    loading: false,
  },
  computed: mapState({
    name: (state) => state.name,
    userInfo: (state) => state.user.userinfo,
  }),
  created () {
    //清除session中的用户信息
    sessionStorage.clear();
    this.getCaptcha();
    this.getAccessToken()
  },
  watch: {
    user: {
      handler: function (newvalue, oldvalue) {
        this.loginInfoError = false;
      },
      deep: true,
    },
  },
  methods: {
    getAccessToken () {
      let self = this
      SSO.getLoginState(function (resultObj) {
        if (resultObj.code == 1001) {
          SSO.getAccessToken(function (response) {
            console.log('res', response);
            if (response && response.result === 'success') {
              self.afterSSOSuccess(response.data)
            } else {
              self.$alert('用户信息已过期，自动登录失败！', '提示')
            }
          })

        } else {
          // self.$alert('用户信息已过期，自动登录失败！', '提示')
        }
      })

    },


    chooseRole: function (val) {
      let self = this;
      self.redirect(val);
    },
    login: function () {
      let self = this;
      self.loginInfoError = false;
      let store = this.$store;
      let userName = this.user.username.replace(regex.aroundSpace, "");
      let passWord = this.user.password.replace(regex.aroundSpace, "");
      let captchaCode = this.user.captchaCode.replace(regex.aroundSpace, "");
      if (userName === "" && passWord === "") {
        self.loginInfoError = true;
        self.msg = "登录信息为空";
        return;
      }
      if (userName === "") {
        self.loginInfoError = true;
        self.msg = "账号为空";
        return;
      }
      if (passWord === "") {
        self.loginInfoError = true;
        self.msg = "密码为空";
        return;
      }
      if (captchaCode === "" && this.codeType === "pic") {
        self.loginInfoError = true;
        self.msg = "验证码为空";
        return;
      }
      self.loading = true;
      console.log("开启loading");
      if (SSO.captchaType === SSO.picCaptchaType) {
        if (captchaCode === "") {
          self.loginInfoError = true;
          self.msg = "请输入验证码";
          this.getCaptcha();
          return;
        }
        const loginParams = {
          account: userName,
          password: passWord,
          captchaCode: captchaCode,
        };
        this.SSOLogin(loginParams);
      } else if (SSO.captchaType === SSO.thirdCaptchaType) {
        // 滑块验证
        SSO.verify();
      }else{}
    },
    afterSSOSuccess (result) {
      let self = this
      let param = {
        token: result.token,
        deviceId: SSO.deviceId,
        deviceName: SSO.client,
        osType: self.getOsType(),
        flush: true,
      };
      console.log("getLoginUserInfo", param);
      store.commit("UPDATE_TOKEN", result.token);
      store.commit("UPDATE_MAC", result.mac);
      sessionStorage.setItem("tgt", result.tgt);
      //获取用户信息
      getLoginUserInfo(param)
        .then(function (res) {
          self.loading = false;
          console.log(res);
          let loginResult = res.data;
          if (res.statusCode == constants.interfaceResult.error) {
            self.loginInfoError = true;
            self.msg = res.message;
            self.getCaptcha();
            return;
          } else if (res.statusCode == constants.interfaceResult.noRight) {
            self.loginInfoError = true;
            self.msg = res.message;
            self.getCaptcha();
            return;
          } else if (
            res.statusCode == constants.interfaceResult.tokenfail
          ) {
            self.loginInfoError = true;
            self.msg = "获取用户信息失败";
            self.getCaptcha();
            return;
          } else {
            if (loginResult == null) {
              self.loginInfoError = true;
              self.msg = "获取用户信息失败";
              self.getCaptcha();
              return;
            }
          }
          loginResult.roleCodes = self.checkRoleCode(loginResult.roleCodes);
          if (loginResult.roleCodes.length == 0) {
            self.loginInfoError = true;
            self.msg = "该账号没有权限登录系统";
            self.getCaptcha();
            return;
          }
          // if (loginResult.roleCodes[0] == "student") {
          //   self.loginInfoError = true;
          //   self.msg = "暂未开放权限";
          //   self.getCaptcha();
          //   return;
          // }
          let params = {
            userId: loginResult.userId,
          };
          store.commit("USER_SIGNIN", loginResult);
          //设置cookie,访问资源需要使用
          var _config = config.getConfig().apiConfig;
          SSO.setCookie("appkey", _config.appId, 1);
          SSO.setCookie("token", result.token, 1);
          SSO.setCookie("clientType", "web", 1);
          self.loginInfoError = false;
          if (loginResult.roleCodes.length == 1) {
            self.redirect(loginResult.roleCodes[0]);
          } else {
            self.loginPass = true;
          }
        })
        .catch((res) => {
          self.loginInfoError = true;
          self.loading = false;
          self.msg = "服务器异常！";
          self.getCaptcha();
        });

    },
    // SSO封装登录接口
    SSOLogin (loginParams) {
      let self = this;
      SSO.loginExt(loginParams, function (res) {
        let result = res.data;
        console.log("loginExt返回", res);
        if (!!result.token) {
          //代表该用户存在
          self.afterSSOSuccess(result)
        } else {
          self.loading = false;
          if (loginConstants.login_Info.loginErrCode == res.code) {
            self.msg = res.data;
          } else if (loginConstants.login_Info.captchaCodeErr == res.code) {
            self.msg = res.data;
          } else {
            self.msg = "账号或密码错误";
          }
          self.loginInfoError = true;
          self.getCaptcha();
          return;
        }
      });
    },
    //获取权限集合
    getAuthList: function (item) {
      let self = this;
      return new Promise((resolve, reject) => {
        let param = {};
        let result = false;
        param.role = [item];
        listRoleAuth(param).then((res) => {
          console.log(res);
          console.log("【authList】:" + res);
          if (res != null && res.length > 0) {
            localStorage.setItem("roleCodes", JSON.stringify(res));
            resolve(true);
          } else {
            self.$message({
              message: "获取列表失败",
              type: "error",
              offset: 135,
            });
            reject(false);
          }
        });
      });
    },

    //跳转
    redirect: function (item) {
      let self = this;
      store.commit("USER_ROLE", item);
      this.getAuthList(item).then((res) => {
        if (res) {
          storage.setSessionStorage("role", item);
          if (item == "teacher") {
            getlistTeacherClassInfo({
              studentCount: true,
              schoolId: self.userInfo.schoolId,
              teacherId: self.userInfo.userId,
              subjectCode: "01",
            })
              .then(function (classResult) {
                store.commit("USER_CLASS", classResult.data);
                // analysisRedirect.redirect2Index();
                window.location.href = "exam.html";
              })
              .catch((res) => {
                self.loginInfoError = true;
                self.msg = res;
                self.getCaptcha();
              });
          } else if (item === "student") {
            window.location.href = "examHistoryReport.html";
          } else if (item === "instructor") {
            window.location.href = "plan.html";
          } else if (item === "subjectLeader") {
            getlistTeacherClassInfo({
              studentCount: true,
              schoolId: self.userInfo.schoolId,
              teacherId: self.userInfo.userId,
              subjectCode: "01",
            })
              .then(function (classResult) {
                store.commit("USER_CLASS", classResult.data);
                // analysisRedirect.redirect2Index();
                window.location.href = "mock.html";
              })
              .catch((res) => {
                self.loginInfoError = true;
                self.msg = res;
                self.getCaptcha();
              });
          } else {
            analysisRedirect.redirect2Index();
          }
        }
      });
    },
    //关闭身份选择
    closeChoose: function () {
      let self = this;
      self.loginPass = false;
    },
    //过滤角色
    checkRoleCode: function (roles) {
      if (roles == undefined) {
        return [];
      }
      let self = this;
      let tempcode = [];
      roles.forEach(function (item, index) {
        if (utils.isInArray(item, self.roleCodes)) {
          tempcode.push(item);
        }
      });
      return tempcode;
    },
    openold: function () {
      window.open(this.oldaddress);
    },
    // 验证码
    getCaptcha () {
      SSO.getCaptcha({
        getCaptchaResultCB: (result) => this.getCaptchaResultCB(result),
        captchaSuccessResultCB: (result) => this.captchaSuccessResultCB(result),
        captchaCloseCB: (result) => {
          this.captchaCloseCB(result);
        },
      });
    },
    captchaCloseCB () {
      this.loading = false;
    },
    // 获取验证信息
    getCaptchaResultCB (resultObj) {
      console.log(resultObj, "getCaptchaResultCB");
      if (resultObj && resultObj.code === "success") {
        let captchaData = resultObj.data;
        if (captchaData.captchaType) {
          this.codeType = captchaData.captchaType;
        }
        if (
          captchaData.captchaType === SSO.picCaptchaType &&
          captchaData.captchaUrl
        ) {
          console.log("进行图形验证");
          // 图形验证
          this.captchaUrl = captchaData.captchaUrl;
        }
      }
    },
    // 极验验证成功回调
    captchaSuccessResultCB (resultObj) {
      console.log("极验被成功调用");
      let userName = this.user.username.replace(regex.aroundSpace, "");
      let passWord = this.user.password.replace(regex.aroundSpace, "");
      const loginParams = {
        account: userName,
        password: passWord,
      };
      this.SSOLogin(loginParams);
    },
    // 判断设备类型
    getOsType () {
      let sUserAgent = navigator.userAgent.toLowerCase();
      if (/msie/i.test(sUserAgent) && !/opera/.test(sUserAgent)) {
        return "ie";
      } else if (/firefox/i.test(sUserAgent)) {
        return "firefox";
      } else if (/chrome/i.test(sUserAgent)) {
        return "chrome";
      } else if (/opera/i.test(sUserAgent)) {
        return "opera";
      } else if (
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent)
      ) {
        return "safari";
      } else if (/edg/i.test(sUserAgent)) {
        return "edge";
      } else if (/360/i.test(sUserAgent)) {
        return "360";
      } else if (/se 2.x/i.test(sUserAgent)) {
        return "sogou";
      } else if (/qqbrowser/i.test(sUserAgent)) {
        return "qq";
      } else if (/baidu/i.test(sUserAgent)) {
        return "baidu";
      } else if (/uc/i.test(sUserAgent)) {
        return "uc";
      } else {
        return "other";
      }
    },
  },
  mounted () { },
  destroyed () { },
});



// WEBPACK FOOTER //
// ./src/controller/login/login_main.js